<!-- バックヤード > 会員お知らせ編集 -->
<template>
  <div>
    <v-row>
      <v-col>
        <div class="float-right">
          <v-btn @click="noticeMemberCancel">
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            @click="noticeMemberSave"
          >
            保存
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <Form />

    <v-row>
      <v-col cols="6">
        <v-btn
          color="error"
          @click="noticeMemberDelete"
        >
          削除
        </v-btn>
      </v-col>
      <v-col cols="6">
        <div class="float-right">
          <v-btn @click="noticeMemberCancel">
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            @click="noticeMemberSave"
          >
            保存
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <Confirm ref="confirm" />
  </div>
</template>

<script>
  import Utils from "../../../mixins/Utils";
  import Confirm from "../../../components/Confirm";
  import Form from "./_Form";

  export default {
    components: {
      Confirm,
      Form,
    },
    mixins: [
      Utils,
    ],
    data () {
      return {
      }
    },
    methods: {
      noticeMemberCancel: function () {
        this.$router.push({name: 'byNoticeMemberIndex'})
      },
      noticeMemberDelete: function () {
        this.$refs.confirm.showDeleteConfirm().then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            this.$router.push({name: 'byNoticeMemberIndex'})
          }
        })
      },
      noticeMemberSave: function () {
        this.$router.push({name: 'byNoticeMemberIndex'})
      },
    },
  }
</script>

<style lang="scss">

</style>
